import api from "@/services/api";

const _http = {
  // GET LIST
  getMonitoring(params) {
    return api.get("/monitoring-document", { params });
  },

  getMonitoringById(id) {
    return api.get(`/monitoring-document/${id}`);
  },

  getAddendumList(refId) {
    return api.get(`/monitoring-document/${refId}/addendum`);
  },
  getTimeline(id) {
    return api.get(`/monitoring-document/${id}/timeline`);
  },
  getSignedUrl(key) {
    return api.get("/s3-signed-url", { params: { key } });
  },
  getPks(params) {
    return api.get("/monitoring-document/pks", { params });
  },

  getPrevCandidates(id) {
    return api.get(`/monitoring-document/${id}/prev-candidates`);
  },
  
  // CREATE
  createMonitoring(data) {
    const isFormData = data instanceof FormData;
    return api.post("/monitoring-document", data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    });
  },

  updateMonitoring(id, data) {
    const isFormData = data instanceof FormData;
    return api.put(`/monitoring-document/${id}`, data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    });
  },
};

export default {
  async getAll(query = {}) {
    try {
      const res = await _http.getMonitoring(query);
      return {
        data: res.data.data.map((item) => item),
        total: res.data.total || 0,
        expired: res.data.expired || 0,
      };
    } catch (error) {
      console.error(error);
      return { data: [], total: 0, expired: 0 };
    }
  },

  async getById(id) {
    try {
      const res = await _http.getMonitoringById(id);
      return res.data.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async getAddendumList(refId) {
    try {
      const res = await _http.getAddendumList(refId);
      const rawData = res.data?.data?.data || res.data?.data || [];

      if (!Array.isArray(rawData)) {
        console.warn("getAddendumList: data bukan array", rawData);
        return [];
      }

      return rawData.map((item) => item);
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getPks(query = {}) {
    try {
      const res = await _http.getPks(query);
      const raw = res.data.data?.data || res.data.data || []; // ← fix nested
      return {
        data: Array.isArray(raw) ? raw.map((item) => item) : [],
        total: res.data.data?.total || 0,
        pending: res.data.data?.pending || 0,
      };
    } catch (error) {
      console.error(error);
      return { data: [], total: 0, pending: 0 };
    }
  },

  async getPrevCandidates(id) {
    try {
      const res = await _http.getPrevCandidates(id);
      return res.data?.data || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getSignedUrl(key) {
    try {
      const res = await _http.getSignedUrl(key);
      return res.data;
    } catch (error) {
      console.error("Error getting signed URL:", error);
      throw error;
    }
  },

  async getTimeline(id) {
    try {
      const res = await _http.getTimeline(id);
      let raw = res?.data?.data ?? res?.data ?? [];
      if (raw && !Array.isArray(raw) && Array.isArray(raw.data)) {
        raw = raw.data;
      }
      if (!Array.isArray(raw)) return [];
      return raw;
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async create(payload) {
    try {
      return await _http.createMonitoring(payload);
    } catch (error) {
      console.error("Error creating document:", error);
      throw error;
    }
  },

  async update(id, payload) {
    try {
      return await _http.updateMonitoring(id, payload);
    } catch (error) {
      console.error("Error updating document:", error);
      throw error;
    }
  },
};
